<template>
  <v-row class="layers-loader my-0" style="max-width: 75%">
    <v-col>
      <v-row no-gutters v-for="item of items" :key="item.id" align="center">
        <template v-if="item.loading">
          <v-col
            cols="auto"
            class="font-weight-bold text-body-2 px-1 layers-loader-col"
          >{{$i18n.t('default.loadingWms')}}</v-col>
          <v-col
            cols="auto"
            class="font-weight-bold text-body-2 px-1 layers-loader-col"
          >{{item.name[$i18n.locale]}}</v-col>
          <v-col cols="auto" class="px-1">
            <v-progress-circular color="primary" indeterminate size="25" />
          </v-col>
        </template>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    items: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.layers-loader {
  position: absolute;
  z-index: 5;
  right: 50px;
  bottom: 4px;
}
.layers-loader-col {
  color: var(--v-primary-base);
}
</style>